const SizeVariant = {
  SMALL: 'small',
  REGULAR: 'regular'
}

export { SizeVariant }
